import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70ca1fa2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "page-heading" }, "Tuition Fees", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Here you can find information about your tuition fees and how to pay them. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " An invoice is issued in advance of each semester of study, with payment due before the start of the semester. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Note that if you have been awarded a scholarship, the scholarship amount will be deducted from your invoice below. No invoice will be made if you have been awarded a full scholarship. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Tuition fees do not apply for exchange students, PhD students or EU/EEA students. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " You can make your payment by credit/debit card (Visa, MasterCard) online. The amount will then be withdrawn from your bank account immediately. You can also transfer the money to our account number. (Note that in the event of a possible refund at a later stage, the payment would be made to the same account as the original payment was made from.) ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Please see further instructions regarding payment methods by clicking on \"Payment by card\", or \"Payment by bank transfer\" in the menu below. ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " The status of the invoice will change to \"paid\" when the amount has been received and registered at Lund University. This may take a couple of days. You will also receive an email that confirms your payment. ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "page-heading" }, "Unpaid invoices", -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "You have no unpaid invoices.", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "invoice-no"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { key: 4 }
const _hoisted_19 = { key: 5 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Payment by card")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Payment by bank transfer")
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "Payment in progress", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { key: 3 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "page-heading" }, "Paid invoices", -1))
const _hoisted_31 = { key: 3 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "You have no paid invoices.", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 0,
  class: "invoice-no"
}
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { key: 3 }
const _hoisted_39 = { key: 4 }
const _hoisted_40 = { key: 5 }
const _hoisted_41 = {
  key: 0,
  class: "invoice-no"
}
const _hoisted_42 = { key: 1 }
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = { key: 3 }
const _hoisted_45 = { key: 4 }
const _hoisted_46 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MirroringUserBanner = _resolveComponent("MirroringUserBanner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (this.isMirroringUser)
      ? (_openBlock(), _createBlock(_component_MirroringUserBanner, {
          key: 0,
          personalId: _ctx.personalId,
          personName: _ctx.personName,
          lucatId: _ctx.lucatId
        }, null, 8, ["personalId", "personName", "lucatId"]))
      : _createCommentVNode("", true),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9,
    (_ctx.unpaidInvoices.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
      : _createCommentVNode("", true),
    (_ctx.unpaidInvoices.length > 0)
      ? (_openBlock(), _createBlock(_component_Table, {
          key: 2,
          rows: _ctx.unpaidInvoices,
          hiddenColumns: ['pending'],
          overrideColWidthCalculation: true
        }, {
          td: _withCtx((data) => [
            (data.col === 'fakNr')
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Invoice no."))
              : _createCommentVNode("", true),
            (data.col === 'totalAmount')
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Total amount (SEK)"))
              : _createCommentVNode("", true),
            (data.col === 'amountDue')
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Amount due (SEK)"))
              : _createCommentVNode("", true),
            (data.col === 'dueDate')
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Due date"))
              : _createCommentVNode("", true),
            (data.col === 'description')
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Description"))
              : (data.col === 'links')
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, " "))
                : _createCommentVNode("", true)
          ]),
          default: _withCtx((data) => [
            (data.col === 'dueDate')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(
          _ctx.getDateClass(
            data.val,
            data.row.amountDue,
            data.row.totalAmount,
            data.row.pending
          )
        )
                }, _toDisplayString(_ctx.formatDate(data.val)), 3))
              : (data.col === 'links')
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                    (!data.row.pending)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                          _createVNode(_component_router_link, {
                            to: {
              name: 'CardPayment',
              params: { invoiceNo: data.row.fakNr },
            }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_22
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          _hoisted_23,
                          _createVNode(_component_router_link, {
                            to: {
              name: 'BankTransfer',
              params: { invoiceNo: data.row.fakNr },
            }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_24
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_25, _hoisted_27))
                  ]))
                : (data.col === 'description')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 2,
                      innerHTML: data.val,
                      class: "wrap-content"
                    }, null, 8, _hoisted_28))
                  : (data.col !== 'dueDate' && data.col !== 'links')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(data.val), 1))
                    : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["rows"]))
      : _createCommentVNode("", true),
    _hoisted_30,
    (_ctx.paidInvoices.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_34))
      : _createCommentVNode("", true),
    (_ctx.paidInvoices.length > 0)
      ? (_openBlock(), _createBlock(_component_Table, {
          key: 4,
          rows: _ctx.paidInvoices,
          hiddenColumns: ['amountDue', 'pending'],
          overrideColWidthCalculation: true
        }, {
          td: _withCtx((data) => [
            (data.col === 'fakNr')
              ? (_openBlock(), _createElementBlock("span", _hoisted_35, "Invoice no."))
              : _createCommentVNode("", true),
            (data.col === 'totalAmount')
              ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Total amount (SEK)"))
              : _createCommentVNode("", true),
            (data.col === 'amountDue')
              ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Amount due (SEK)"))
              : _createCommentVNode("", true),
            (data.col === 'dueDate')
              ? (_openBlock(), _createElementBlock("span", _hoisted_38, "Due date"))
              : _createCommentVNode("", true),
            (data.col === 'description')
              ? (_openBlock(), _createElementBlock("span", _hoisted_39, "Description"))
              : (data.col === 'links')
                ? (_openBlock(), _createElementBlock("span", _hoisted_40, " "))
                : _createCommentVNode("", true)
          ]),
          default: _withCtx((data) => [
            (data.col === 'fakNr')
              ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(data.val), 1))
              : _createCommentVNode("", true),
            (data.col === 'dueDate')
              ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.formatDate(data.val, data.row.amountDue, data.row.totalAmount)), 1))
              : (data.col === 'description')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    innerHTML: data.val,
                    class: "wrap-content"
                  }, null, 8, _hoisted_43))
                : (
          data.col !== 'fakNr' && data.col !== 'dueDate' && data.col !== 'links'
        )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(data.val), 1))
                  : (data.col === 'links')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                        _createElementVNode("a", {
                          href: "javascript:void(0);",
                          onClick: _withModifiers(($event: any) => (_ctx.downloadInvoice(data.row.fakNr)), ["prevent"])
                        }, "Download invoice", 8, _hoisted_46)
                      ]))
                    : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["rows"]))
      : _createCommentVNode("", true)
  ], 64))
}